/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

const kLSParserKey = 'parser';

export function saveParserWithApp(app, scripts) {
  window.localStorage.setItem(app, scripts);
}

export function loadParserWithApp(app) {
  return (window.localStorage.getItem(app) || '').trim();
}

export function saveParser(scripts) {
  window.localStorage.setItem(kLSParserKey, scripts);
}

export function loadParser() {
  return (window.localStorage.getItem(kLSParserKey) || '').trim();
}

function evalInCtx(script) {
  return eval(script);
}

function evalScript(ctx, script) {
  let s = '';
  _.forOwn(ctx, (value, name) => {
    s = `${s}\nvar ${name}=this['${name}'];`;
  });
  try {
    return [evalInCtx.call(ctx, s + script), null];
  } catch (e) {
    return [null, e];
  }
}

function dehex(str) {
  const bin = [];
  const hex = [];
  let s = str;
  while (s.length >= 2) {
    const value = s.substring(0, 2);
    bin.push(parseInt(value, 16));
    hex.push(value);
    s = str.substring(2, s.length);
  }
  return [bin, hex];
}

export function syntaxCheck(script) {
  const s = '1122334455667788';
  const [bin, hex] = dehex(s);
  const [_, e] = evalScript({
    data: s,
    bin,
    hex,
    appeui: s,
    deveui: s,
    fport: 1,
  }, script);
  return e && e.message;
}

export function transform(parser, datalist) {
  return datalist.slice(0, 20).map((obj) => {
    if (parser && !obj.error) {
      if (!obj._raw_) {
        obj._raw_ = obj.data
      }
      const [bin, hex] = dehex(obj._raw_);
      [obj.data] = evalScript(
        {
          data: obj._raw_,
          bin,
          hex,
          appeui: obj.appeui,
          deveui: obj.deveui,
          fport: obj.fport,
        },
        parser);
    } else if (!obj._raw_) {
      obj._raw_ = obj.data;
    } else {
      obj.data = obj._raw_;
    }
    return obj;
  });
}




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/AppDebug/func/parser.js